module.exports = __webpack_public_path__ + "img/39.d68a1c63.jpg";